var Level = /* @__PURE__ */ ((Level2) => {
  Level2["CRITICAL"] = "CRITICAL";
  Level2["DANGER"] = "DANGER";
  Level2["WARNING"] = "WARNING";
  Level2["NOTICE"] = "NOTICE";
  Level2["INFO"] = "INFO";
  return Level2;
})(Level || {});
var Flag = /* @__PURE__ */ ((Flag2) => {
  Flag2["ORDER"] = "ORDER";
  Flag2["VALIDATION"] = "VALIDATION";
  return Flag2;
})(Flag || {});
var FrontService = /* @__PURE__ */ ((FrontService2) => {
  FrontService2["MTICKET"] = "MTICKET";
  FrontService2["APP_MULTIPLE_NETWORK"] = "APP_MULTIPLE_NETWORK";
  FrontService2["ESHOP"] = "ESHOP";
  FrontService2["SCHOOL_ESHOP"] = "SCHOOL_ESHOP";
  FrontService2["WEB_SCOOP"] = "WEB_SCOOP";
  FrontService2["APP_SCOOP"] = "APP_SCOOP";
  return FrontService2;
})(FrontService || {});
var BaseChannel = /* @__PURE__ */ ((BaseChannel2) => {
  BaseChannel2["GLOBAL"] = "global";
  BaseChannel2["NETWORK"] = "network";
  return BaseChannel2;
})(BaseChannel || {});

var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _sources, _fetch, fetch_fn, _getSourceArrayIndex, getSourceArrayIndex_fn;
const _UpkeepFrontendClient = class _UpkeepFrontendClient {
  /**
   * Create a new UpkeepFrontendClient.
   * @param {string[]} urls - The URLs to prepare sources from.
   * @param {Option} options - The options for the client.
   */
  constructor(urls, options) {
    this.options = options;
    /**
     * Fetch data from the sources.
     * @param {Filter} filters - The filters to apply.
     * @return {Promise<FetchResponse | null>} The fetch response or null.
     */
    __privateAdd(this, _fetch);
    /**
     * Get the index of a source in the sources array.
     * @param {string} index - The index to search for.
     * @return {number} The found index or -1.
     */
    __privateAdd(this, _getSourceArrayIndex);
    __privateAdd(this, _sources, void 0);
    __privateSet(this, _sources, _UpkeepFrontendClient.prepareSources(urls));
  }
  /**
   * Get network maintenance alerts.
   * @param {number} networkId - The ID of the network.
   * @param {FrontService[]} frontServices - The front services to get alerts for.
   * @return {Promise<MaintenanceStatus[]>} The maintenance statuses.
   */
  async getNetworkMaintenanceAlerts(networkId, frontServices) {
    const channelArray = frontServices.reduce(
      (channelList, frontService) => {
        channelList.push(`${BaseChannel.NETWORK}/${networkId}/${frontService}`);
        channelList.push(`${BaseChannel.GLOBAL}/${frontService}`);
        return channelList;
      },
      [BaseChannel.GLOBAL, `${BaseChannel.NETWORK}/${networkId}`]
    );
    return this.getAvailableMaintenanceAlerts(channelArray);
  }
  /**
   * Get available maintenance alerts.
   * @param {string[]} channelArray - The channels to get alerts for.
   * @return {Promise<MaintenanceStatus[]>} The maintenance statuses.
   */
  async getAvailableMaintenanceAlerts(channelArray) {
    const response = await __privateMethod(this, _fetch, fetch_fn).call(this, {
      channel: channelArray.join(","),
      displayed: true
    });
    if (response) {
      return response.payload.filter((maintenanceAlert) => {
        let hasDisplayRangeTime = false;
        const now = /* @__PURE__ */ new Date();
        if (!maintenanceAlert.displayBefore && !maintenanceAlert.displayAfter) {
          hasDisplayRangeTime = true;
        } else if (maintenanceAlert.displayAfter && !maintenanceAlert.displayBefore) {
          const displayAfterDate = new Date(maintenanceAlert.displayAfter);
          hasDisplayRangeTime = now >= displayAfterDate;
        } else if (!maintenanceAlert.displayAfter && maintenanceAlert.displayBefore) {
          const displayBeforeDate = new Date(maintenanceAlert.displayBefore);
          hasDisplayRangeTime = now <= displayBeforeDate;
        } else if (maintenanceAlert.displayBefore && maintenanceAlert.displayAfter) {
          const displayAfterDate = new Date(maintenanceAlert.displayAfter);
          const displayBeforeDate = new Date(maintenanceAlert.displayBefore);
          hasDisplayRangeTime = now >= displayAfterDate && now <= displayBeforeDate;
        }
        return hasDisplayRangeTime;
      }).sort((prevAlert, nextAlert) => {
        return _UpkeepFrontendClient.sortByLevelNumberAndDisplayAfter(prevAlert, nextAlert);
      });
    }
    return [];
  }
  /**
   * Find a global alert.
   * @param {MaintenanceStatus[]} alerts - The alerts to search in.
   * @return {MaintenanceStatus | null} The found alert or null.
   */
  static findGlobalAlert(alerts) {
    let globalAlert = null;
    const tempAlert = alerts.filter((alert) => {
      return alert.flags && alert.flags.length === 0 || !alert.flags;
    }).sort((prevAlert, nextAlert) => {
      return _UpkeepFrontendClient.sortByLevelNumberAndDisplayAfter(prevAlert, nextAlert);
    }).shift();
    if (tempAlert) {
      globalAlert = tempAlert;
    }
    return globalAlert;
  }
  /**
   * Find a flag alert.
   * @param {MaintenanceStatus[]} alerts - The alerts to search in.
   * @param {Flag} flag - The flag to search for.
   * @return {MaintenanceStatus | null} The found alert or null.
   */
  static findFlagAlert(alerts, flag) {
    let flagAlert = null;
    const tempAlert = alerts.filter((alert) => {
      return alert.flags && alert.flags.includes(flag);
    }).sort((prevAlert, nextAlert) => {
      return _UpkeepFrontendClient.sortByLevelNumberAndDisplayAfter(prevAlert, nextAlert);
    }).shift();
    if (tempAlert) {
      flagAlert = tempAlert;
    }
    return flagAlert;
  }
  /**
   * Extract the max age from a response's cache control header.
   * @param {Response} response - The response to extract from.
   * @return {number | null} The max age or null.
   */
  static maybeExtractCacheControlMaxAgeFrom(response) {
    let cacheControl = "";
    const headerCacheControl = response.headers.get("cache-control");
    if (headerCacheControl) {
      cacheControl = headerCacheControl;
    }
    const headerCacheControlMaxAgeMatch = /max-age=(?<seconds>\d+)/gi.exec(cacheControl);
    if (!headerCacheControlMaxAgeMatch)
      return null;
    if (headerCacheControlMaxAgeMatch.groups && headerCacheControlMaxAgeMatch.groups.seconds) {
      return +headerCacheControlMaxAgeMatch.groups.seconds;
    }
    return null;
  }
  /**
   * Prepare sources from URLs.
   * @param {string[]} urls - The URLs to prepare sources from.
   * @return {Source[]} The prepared sources.
   */
  static prepareSources(urls) {
    const sources = [];
    for (const index in urls) {
      const url = urls[index];
      sources.push({
        url,
        index,
        punishedUntil: null,
        cachedUntil: null
      });
    }
    return sources;
  }
  /**
   * Manage a fetch request.
   * @param {string} resource - The resource to fetch.
   * @param {Option} options - The options for the fetch request.
   * @return {Promise<Response>} The response.
   */
  static async manageFetch(resource, options = {}) {
    if (process.server) {
      const nodeVersion = process.versions.node.split(".").map(Number).shift();
      if (nodeVersion && nodeVersion > 16) {
        return _UpkeepFrontendClient.fetchWithTimeout(resource, options);
      } else {
        return _UpkeepFrontendClient.fetchWithoutTimeout(resource);
      }
    } else {
      return _UpkeepFrontendClient.fetchWithTimeout(resource, options);
    }
  }
  /**
   * Fetch a resource with a timeout.
   * @param {string} resource - The resource to fetch.
   * @param {Option} options - The options for the fetch request.
   * @return {Promise<Response>} The response.
   */
  static async fetchWithTimeout(resource, options = {}) {
    const { timeout = 8e3 } = options;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const response = await fetch(resource, {
      ...options,
      signal: controller.signal
    });
    clearTimeout(id);
    return response;
  }
  /**
   * Fetch a resource without a timeout.
   * @param {string} resource - The resource to fetch.
   * @return {Promise<Response>} The response.
   */
  static fetchWithoutTimeout(resource) {
    return fetch(resource);
  }
  /**
   * Make a date plus milliseconds.
   * @param {number} milliseconds - The milliseconds to add.
   * @param {Date} date - The date to add to.
   * @return {Date} The new date.
   */
  static makeDatePlusMilliseconds(milliseconds = 0, date = /* @__PURE__ */ new Date()) {
    date.setMilliseconds(date.getMilliseconds() + milliseconds);
    return date;
  }
  /**
   * Get the level number of an alert.
   * @param {MaintenanceStatus} alert - The alert to get the level number for.
   * @return {number} The level number.
   */
  static getAlertLevelNumber(alert) {
    switch (alert.level) {
      case Level.CRITICAL:
        return 5;
      case Level.DANGER:
        return 4;
      case Level.WARNING:
        return 3;
      case Level.NOTICE:
        return 2;
      default:
      case Level.INFO:
        return 1;
    }
  }
  /**
   * Sort alerts by level number and display after.
   * @param {MaintenanceStatus} prevAlert - The previous alert.
   * @param {MaintenanceStatus} nextAlert - The next alert.
   * @return {number} The sort order.
   */
  static sortByLevelNumberAndDisplayAfter(prevAlert, nextAlert) {
    if (_UpkeepFrontendClient.getAlertLevelNumber(prevAlert) !== _UpkeepFrontendClient.getAlertLevelNumber(nextAlert)) {
      return _UpkeepFrontendClient.getAlertLevelNumber(nextAlert) - _UpkeepFrontendClient.getAlertLevelNumber(prevAlert);
    }
    if (!nextAlert.displayAfter) {
      return 1;
    }
    if (!prevAlert.displayAfter) {
      return -1;
    }
    const prevDisplayAfter = new Date(prevAlert.displayAfter).valueOf();
    const nextDisplayAfter = new Date(nextAlert.displayAfter).valueOf();
    return nextDisplayAfter - prevDisplayAfter;
  }
};
_sources = new WeakMap();
_fetch = new WeakSet();
fetch_fn = async function(filters) {
  const startDate = /* @__PURE__ */ new Date();
  const startTime = startDate.getTime();
  for (const source of __privateGet(this, _sources)) {
    if (source.punishedUntil && source.punishedUntil > startDate) {
      continue;
    }
    try {
      const sourceRequestUrl = new URL(source.url);
      for (const [key, filter] of Object.entries(filters)) {
        sourceRequestUrl.searchParams.append(key, filter);
      }
      const sourceRequestUrlString = sourceRequestUrl.toString();
      let timeout = 1e3;
      if (typeof this.options.timeout === "number") {
        timeout = this.options.timeout;
      }
      const response = await _UpkeepFrontendClient.manageFetch(sourceRequestUrlString, {
        timeout
      });
      const isCached = Boolean(source.cachedUntil && source.cachedUntil > startDate);
      if (!isCached) {
        const headerCacheControlMaxAge = _UpkeepFrontendClient.maybeExtractCacheControlMaxAgeFrom(response);
        if (headerCacheControlMaxAge !== null) {
          const cachedUntil = _UpkeepFrontendClient.makeDatePlusMilliseconds(
            headerCacheControlMaxAge * 1e3
          );
          source.cachedUntil = cachedUntil;
        }
      }
      const maintenanceStatusList = await response.json();
      const successTime = Date.now();
      return {
        isCached,
        time: successTime - startTime,
        payload: maintenanceStatusList,
        source
      };
    } catch (e) {
      let punishTime = 1e4;
      if (typeof this.options.punishTime === "number") {
        punishTime = this.options.punishTime;
      }
      const punishedUntil = _UpkeepFrontendClient.makeDatePlusMilliseconds(punishTime);
      const sourceIndex = __privateMethod(this, _getSourceArrayIndex, getSourceArrayIndex_fn).call(this, source.index);
      if (sourceIndex > -1) {
        __privateGet(this, _sources)[sourceIndex].punishedUntil = punishedUntil;
      }
      continue;
    }
  }
  return null;
};
_getSourceArrayIndex = new WeakSet();
getSourceArrayIndex_fn = function(index) {
  return __privateGet(this, _sources).findIndex((source) => source.index === index);
};
let UpkeepFrontendClient = _UpkeepFrontendClient;

export { BaseChannel, Flag, FrontService, Level, UpkeepFrontendClient };
